
import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { withTranslation } from "react-i18next";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import SaveButton from 'components/buttons/save';
import { API_URL } from "../../../helpers/app_url";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import ContactDetailMenu from '../menu/detail-menu'
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import TitleDropdowns from "components/dropdowns/Other/titleDropdowns"
import { getContactDetail } from "../../../store/actions";
import ContactData from '../forms/contact-data';
import classnames from "classnames"
import { map } from 'lodash';
import ActionDelete from 'components/buttons/actionDelete';
import Moment from 'react-moment';
import Swal from 'sweetalert2';
import PhoneInputField from 'components/dropdowns/PhoneInputField';
import moment from 'moment';
import SafeField from "helpers/SafeField";
class ContactAdditionProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titles: [],
      activeTab: "1",
      importantDates:[]
    };
    this.toggle = this.toggle.bind(this);
    this.handleImpDateDelete = this.handleImpDateDelete.bind(this);
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }
  componentDidMount() {
    const { match: { params }, onGetContactDetail } = this.props;
    if (params && params.id) {
      onGetContactDetail(params.contactid);
      this.fetchSecondaryDetail(params.id);
    }
  }
  handelImpDate = (values, { setSubmitting, resetForm }) => {
  const submissionData = {
    contactId: parseInt(values.contactId),
    agentId: parseInt(values.agentId),
    dateTitle: values.dateTitle,
    dateMonth: parseInt(values.dateMonth),
    dateDay: parseInt(values.dateDay),
    isActive: true
  };

  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj.resultData.bearerToken;
  const str = "Bearer " + token;
  toast.loading("Please wait...");
  axios.post(API_URL + `ContactImportantDate`, submissionData, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': str
    }
  })
    .then(response => {
      toast.dismiss();
      if (response.data.success === true) {
        toast.success("Saved successfully.");
         this.fetchImpDate({ contactId: this.props.match.params.id, agentId: localStorage.getItem('userId') });
        resetForm();
      } else {
        toast.error("Some error occurred");
      }
    })
    .catch(error => {
      toast.dismiss();
      console.error('Error submitting form:', error);
      toast.error("Submission failed");
    })
    .finally(() => {
      setSubmitting(false);
    });
  };

  fetchImpDate(params = {}) {
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;

  axios.get(`${API_URL}ContactImportantDate/all`, {
    headers: { Authorization: `Bearer ${token}` },
    params: params 
  })
  .then(secondResponse => {
    this.setState({
      importantDates: secondResponse.data || [], 
      isLoading: false,
    });
  })
  .catch(error => {
    console.error('Error fetching data from second API:', error);
    this.setState({ isLoading: false });
  });
}


 

 handleChildSubmit = (values, { setSubmitting, resetForm }) => {
  const submissionData = {
    contactId: parseInt(values.contactId),
    childName: values.childName,
    birthDay: (values.birthDay) ? moment(values.birthDay).format('YYYY-MM-DD') : null,
    cGender:0,
    cChildIsActive: true,
    agentId: parseInt(localStorage.getItem('userId'))
  };
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj.resultData.bearerToken;
  const str = "Bearer " + token;
  toast.loading("Please wait...");
  axios.post(API_URL + `ContactChild`, submissionData, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': str
    }
  })
    .then(response => {
      
      if (response.data.success === true) {
        toast.dismiss();
        toast.success("Saved successfully.");
         this.fetchChild({ contactId: this.props.match.params.id, agentId:localStorage.getItem('userId') });
        resetForm();
      } else {
        const errorMsg = response?.data?.validationErrors?.[0] || "Validation failed";
         toast.dismiss();
          toast.warning(errorMsg);
      }
    })
    .catch(error => {
      toast.dismiss();
      console.error('Error submitting form:', error);
      toast.error("Submission failed");
    })
    .finally(() => {
      setSubmitting(false);
    });
  };

  fetchChild(params = {}) {
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;

  axios.get(`${API_URL}ContactChild/all`, {
    headers: { Authorization: `Bearer ${token}` },
    params: params 
  })
  .then(secondResponse => {
    this.setState({
      childs: secondResponse.data || [], 
      isLoading: false,
    });
  })
  .catch(error => {
    console.error('Error fetching data from second API:', error);
    this.setState({ isLoading: false });
  });
}


handleImpDateDelete = async (id) => {
  const confirmResult = await Swal.fire({
    title: 'Are you sure?',
    text: 'This action cannot be undone!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
  });

  if (confirmResult.isConfirmed) {
    try {
       const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;

      await axios.delete(`${API_URL}ContactImportantDate/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      this.setState(prevState => ({
        importantDates: prevState.importantDates.filter(item => item.id !== id)
      }));

      Swal.fire('Deleted!', 'successfully.', 'success');
    } catch (error) {
      console.error('Delete failed:', error);
      Swal.fire('Error', 'Failed to delete the item.', 'error');
    }
  }
};
handleIChildDelete = async (id) => {
  const confirmResult = await Swal.fire({
    title: 'Are you sure?',
    text: 'This action cannot be undone!',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Yes, delete it!',
  });

  if (confirmResult.isConfirmed) {
    try {
       const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;

      await axios.delete(`${API_URL}ContactChild/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      this.setState(prevState => ({
        childs: prevState.childs.filter(item => item.id !== id)
      }));

      Swal.fire('Deleted!', 'The item has been deleted.', 'success');
    } catch (error) {
      console.error('Delete failed:', error);
      Swal.fire('Error', 'Failed to delete the item.', 'error');
    }
  }
};

fetchSecondaryDetail(id) {
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;

  axios.get(`${API_URL}ContactContactExt/get_Contact_secondary_contact_ext_by_Contactid/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
  .then(response => {
    const firstContact = (response.data && response.data.length > 0) ? response.data[0] : {};
    this.setState({
      secContact: firstContact || [], 
      isLoading: false,
    });
  })
  .catch(error => {
    console.error('Error fetching data from second API:', error);
    this.setState({ isLoading: false });
  });
}
handelUpdate = (values, { setSubmitting, resetForm }) => {
  const { id } = values;

  const url =
    id === 0
      ? `${API_URL}ContactContactExt/add_Contactext_secondary_contact`
      : `${API_URL}ContactContactExt/update_Contactext_secondary_contact`;

  const method = id === 0 ? axios.post : axios.put;

  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;
  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };
toast.loading('Please wait.......');
  method(url, values, { headers })
    .then((res) => {
      toast.dismiss();
      toast.success("Saved successfully.");
      if (id === 0) 
      setSubmitting(false);
    })
    .catch((err) => {
      console.error("Error:", err);
      setSubmitting(false);
    });
};
  render() {
   
    const { contactDetail, isResponsive } = this.props;
    const { secContact } = this.state;
   
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Contact Detail | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm="3" className="pe-0">
                <ContactData contactDetail={contactDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm="9" className="ps-0 pe-0">
               {!isResponsive &&(
                <Row className="project-header">
                  <Col sm='8'>
                    <Breadcrumbs
                      title="Contact"
                      breadcrumbItem="Contact Detail"
                    />

                  </Col>
                  <Col sm='4'>
                    <h2>{contactDetail.firstName + " " + contactDetail.lastName}</h2>
                  </Col>
                </Row>
                )}
                <ContactDetailMenu  isResponsive={isResponsive} />
                {isResponsive ? (
                  <Card>
                    <CardBody>
                      <h6>Select</h6>
                       <select
                          className="form-select mb-3"
                          value={this.state.activeTab}
                          onChange={(e) => {
                            const value = e.target.value;
                            this.toggle(value);

                            // Trigger respective API calls
                            switch (value) {
                              case "1":
                                this.fetchSecondaryDetail(this.props.match.params.id, localStorage.getItem('userId'));
                                break;
                              case "2":
                                this.fetchImpDate({ contactId: this.props.match.params.id, agentId: localStorage.getItem('userId')});
                                break;
                              case "3":
                                this.fetchChild({ contactId: this.props.match.params.id, agentId: localStorage.getItem('userId') });
                                break;
                            }
                          }}
                        >
                          <option value="1">{this.props.t("Secondary Contact")}</option>
                          <option value="2">{this.props.t("Important Dates")}</option>
                          <option value="3">{this.props.t("Children")}</option>
                        </select>
                    </CardBody>
                  </Card>
                ):(
                    <Nav
                  tabs
                  className="lead-tab mt-10 mb-10"
                >
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "1",
                      })}
                      onClick={() => {
                        this.toggle("1");
                        this.fetchSecondaryDetail(this.props.match.params.id);
                      }}
                    >
                      <span className="">{this.props.t("Secondary Contact")}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "2",
                      })}
                     onClick={() => {
                        this.toggle("2");
                        this.fetchImpDate({ contactId: this.props.match.params.id, agentId: localStorage.getItem('userId') });
                      }}
                    >
                      <span className="">{this.props.t("Important Dates")}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab === "3",
                      })}
                      onClick={() => {
                        this.toggle("3");
                        this.fetchChild({ contactId: this.props.match.params.id, agentId: localStorage.getItem('userId') });
                      }}
                    >
                      <span className="">{this.props.t("Children")}</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                )}
              
                <TabContent activeTab={this.state.activeTab} className="p-3 text-muted">
                  <TabPane tabId="1">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                            id: secContact?.id || 0,
                            agentId: parseInt(localStorage.getItem('userId')),
                            contactContactId: secContact?.contactContactId	|| '3fa85f64-5717-4562-b3fc-2c963f66afa6',
                            contactId: parseInt(this.props.match.params.id),
                            contactFName	: secContact?.contactFName	|| '',
                            contactLName		: secContact?.contactLName		|| '',
                            cContactId		: secContact?.cContactId		|| 0,
                            cContactIsActive : secContact?.cContactIsActive	|| true,
                            //title	: secContact?.title	|| '',
                            organization	: secContact?.organization	|| '',
                            jobTitle	: secContact?.jobTitle	|| '',
                            mobile  : secContact?.cContact?.mobile	|| '',
                            email	: secContact?.cContact?.email	|| '',
                            office	: secContact?.cContact?.office	|| '',
                            phoneExt	: secContact?.cContact?.phoneExt	|| '',
                            industry: secContact?.industry	|| '',
                      }}
                      validationSchema={Yup.object().shape({
                        // title: Yup.string().required("This Field is Required"),
                        contactFName: Yup.string().required("This Field is Required"),
                        contactLName: Yup.string().required("This Field is Required"),
                        mobile: Yup.string().required("This Field is Required"),
                        email: Yup.string().email().required("This Field is Required"),
                        organization: Yup.string(),
                        jobTitle: Yup.string(),
                        //office: Yup.string().min(10, "Only 10 Digits are allowed").max(10, 'Only 10 Digits are allowed'),
                        //fax: Yup.string().min(3, "Digits should be more than 3").max(6, 'Only 6 Digits are allowed'),
                        //industry: Yup.string().max(100, 'Only 100 Characters are allowed'),
                      })}

                      onSubmit={this.handelUpdate}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Card>
                            <CardBody>
                              <h5 className="card-title">Secondary Contact Details</h5>

                              <Row>
                                {/* <Col sm="1">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="title">
                                      {this.props.t("Title*")}
                                    </Label>
                                    <SafeField
                                      name="title"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.title && touched.title
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="title"
                                    />
                                    <ErrorMessage
                                      name="title"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col> */}

                                <Col sm="3">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="contactFName">
                                      {this.props.t("First Name*")}
                                    </Label>
                                    <SafeField
                                      name="contactFName"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.contactFName && touched.contactFName
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="contactFName"
                                    />
                                    <ErrorMessage
                                      name="contactFName"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col sm="3">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="contactLName">
                                      {this.props.t("Last Name *")}
                                    </Label>
                                    <SafeField
                                      name="contactLName"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.contactLName && touched.contactLName
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="contactLName"
                                    />
                                    <ErrorMessage
                                      name="contactLName"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
                                <Col sm="3">
                                              <PhoneInputField
                                                  label="Mobile"
                                                  name="mobile"
                                                  value={values.mobile}
                                                  setFieldValue={setFieldValue}
                                                  error={errors.mobile}
                                                  touched={touched.mobile}
                                                  country="ca"
                                                  required={true}
                                                />
                               
                                </Col>

                                <Col sm="3">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="email">
                                      {this.props.t("Email*")}
                                    </Label>
                                    <SafeField
                                      name="email"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.email && touched.email
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="email"
                                    />
                                    <ErrorMessage
                                      name="email"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>

                                </Col>


                              </Row>

                              <Row>
                                <Col sm="3">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="organization">
                                      {this.props.t("Company Name")}
                                    </Label>
                                    <SafeField
                                      name="organization"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.organization && touched.organization
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="organization"
                                    />
                                    <ErrorMessage
                                      name="organization"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>

                                </Col>

                                <Col sm="2">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="jobTitle">
                                      {this.props.t("Job Title")}
                                    </Label>
                                    <SafeField
                                      name="jobTitle"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.jobTitle && touched.jobTitle
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="jobTitle"
                                    />
                                    <ErrorMessage
                                      name="jobTitle"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>

                                </Col>

                                <Col sm="3">
                                 <PhoneInputField
                                                  label="Office Phone"
                                                  name="office"
                                                  value={values.office}
                                                  setFieldValue={setFieldValue}
                                                  error={errors.office}
                                                  touched={touched.office}
                                                  country="ca"
                                                  required={false}
                                                />
                              
                                </Col>
                                <Col sm="1">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="phoneExt">
                                      {this.props.t("Ext")}
                                    </Label>
                                    <SafeField
                                      name="phoneExt"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.phoneExt && touched.phoneExt
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="phoneExt"
                                    />
                                    <ErrorMessage
                                      name="phoneExt"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>

                                </Col>

                                <Col sm="3">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="industry">
                                      {this.props.t("Industry")}
                                    </Label>
                                    <SafeField
                                      name="industry"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.industry && touched.industry
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="industry"
                                    />
                                    <ErrorMessage
                                      name="industry"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>

                                </Col>
                                  
                              </Row>
                                <SaveButton>Save</SaveButton>            
                            </CardBody>
                          </Card>
                        </Form>
                      )}
                    </Formik>
                  </TabPane>
                  <TabPane tabId="2">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        contactId	: this.props.match.params.id,
                        agentId: localStorage.getItem('userId'),
                        dateTitle: (this.state && this.state.dateTitle) || "",
                        dateMonth: (this.state && this.state.dateMonth) || "",
                        dateDay: (this.state && this.state.dateDay) || "",
                      }}
                      validationSchema={Yup.object().shape({
                        dateTitle: Yup.string().required("This is Required"),
                        dateMonth: Yup.string().required("This is Required"),
                        dateDay: Yup.string().required("This is Required"),
                      })}

                      onSubmit={this.handelImpDate}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => {
                        const selectedMonth = values.dateMonth;
                        const selectedYear = new Date().getFullYear();
                        const daysInMonth = selectedMonth ? new Date(selectedYear, selectedMonth, 0).getDate() : 31;
                        return (
                          <Form
                            className="needs-validation"
                          >
                            <Card>
                              <CardBody>
                                <h5 className="card-title">Important dates </h5>
                                <Row>
                                  <Col sm="3">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="dateTitle">
                                        {this.props.t("Type ( birthday, anniversary etc)*")}
                                      </Label>
                                      <SafeField
                                        name="dateTitle"
                                        onChange={handleChange}
                                        type="text"

                                        className={
                                          "form-control" +
                                          (errors.dateTitle && touched.dateTitle
                                            ? " is-invalid"
                                            : "")
                                        }

                                        id="dateTitle"
                                      />
                                      <ErrorMessage
                                        name="dateTitle"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>

                                  </Col>

                                  <Col sm="2">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="dateMonth">
                                        {this.props.t("Month*")}
                                      </Label>
                                      <SafeField as="select" name="dateMonth" className={`form-control${errors.dateMonth && touched.dateMonth ? " is-invalid" : ""}`} onChange={(e) => {
                                        handleChange(e);
                                        const selectedMonth = parseInt(e.target.value, 10);
                                        // setFieldValue("dateDay", ''); // Reset day value
                                        setFieldValue("dateMonth", e.target.value); // Set month value
                                      }}>
                                        <option value="">Select</option>
                                        {[...Array(12)].map((_, index) => (
                                          <option key={index + 1} value={index + 1}>{this.props.t(new Date(2000, index, 1).toLocaleString(undefined, { month: 'long' }))}</option>
                                        ))}
                                      </SafeField>
                                      <ErrorMessage name="dateMonth" component="div" className="invalid-feedback" />

                                    </FormGroup>

                                  </Col>

                                  <Col sm="2">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="dateDay">
                                        {this.props.t("Day*")}
                                      </Label>
                                      <SafeField as="select" name="dateDay" className={`form-control${errors.dateDay && touched.dateDay ? " is-invalid" : ""}`} onChange={handleChange}>
                                        <option value="">Select</option>
                                        {[...Array(daysInMonth)].map((_, index) => (
                                          <option key={index + 1} value={index + 1}>{index + 1}</option>
                                        ))}
                                      </SafeField>
                                      <ErrorMessage name="dateDay" component="div" className="invalid-feedback" />

                                    </FormGroup>

                                  </Col>
                                  <Col sm="2">
                                  {isResponsive ? (
                                    <button type="submit" className="btn btn-primary mb-4"><i className=" bx bx-plus-medical"></i></button>
                                  ):(
                                    <button type="submit" className="btn btn-primary mt-27"><i className=" bx bx-plus-medical"></i></button>
                                  )}
                                    

                                  </Col>
                                </Row>

                                <Row>
                                  <Col sm="12">
                                    <h5 className="card-title">Importants Date</h5>
                                    <div className="table-responsive">
                                      <table className="table table-bordered border-primary">
                                        <thead className="">
                                          <tr>
                                            <th style={{ width: "10%" }}>#</th>
                                            <th style={{ width: "30%" }}>Title</th>
                                             <th style={{ width: "20%" }}>Day</th>
                                            <th style={{ width: "20%" }}>Month</th>
                                           
                                            <th style={{ width: "10%" }}>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {map(this.state.importantDates, (importantdate, datekey) => (
                                                        <tr key={"_note_" + datekey}>
                                                        <td>{ datekey + 1 }</td>
                                                        <td> {importantdate.dateTitle} </td>
                                                        <td> {importantdate.dateDay} </td>
                                                        <td> <Moment format='MMM'>{`2025-${importantdate.dateMonth}-01`}</Moment></td>
                                                        
                                                        
                                                        <td><ActionDelete onClick={() => this.handleImpDateDelete(importantdate.id)} /></td>
                                                        </tr>
                                                      ))} 
                                          </tbody>
                                      </table>
                                    </div>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </Form>)
                      }
                      }
                    </Formik>
                  </TabPane>
                  <TabPane tabId="3">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{

                        contactId: this.props.match.params.id,
                        childName: "",
                        birthDay: "",

                      }}
                      validationSchema={Yup.object().shape({
                        childName: Yup.string().required("This is Required"),
                        birthDay: Yup.string().required("This is Required"),
                      })}

                      onSubmit={this.handleChildSubmit}
                    >
                      {({ errors, touched, values, handleChange, setFieldValue }) => (
                        <Form
                          className="needs-validation"
                        >
                          <Card>
                            <CardBody>
                              <h5 className="card-title">Add children</h5>
                              <Row>
                                <Col sm="3">
                                  <FormGroup className="mb-3">
                                    <Label htmlFor="childName">
                                      {this.props.t("Enter Name*")}
                                    </Label>
                                    <SafeField
                                      name="childName"
                                      onChange={handleChange}
                                      type="text"

                                      className={
                                        "form-control" +
                                        (errors.childName && touched.childName
                                          ? " is-invalid"
                                          : "")
                                      }

                                      id="childName"
                                    />
                                    <ErrorMessage
                                      name="childName"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>

                                </Col>

                                <Col sm="3">
                                  <FormGroup className="mb15">

                                    <Label htmlFor="birthDay">
                                      {this.props.t("Date of birth *")}
                                    </Label>
                                    <Flatpickr
                                      className={
                                        "form-control" +
                                        (errors.birthDay && touched.birthDay
                                          ? " is-invalid"
                                          : "")
                                      }
                                      placeholder=""

                                      onChange={(value) => setFieldValue('birthDay', value[0])}
                                      options={{
                                        altInput: false,
                                        altFormat: "F j, Y",
                                        dateFormat: "Y-m-d",
                                        maxDate: "today"
                                      }}
                                    />
                                    <ErrorMessage
                                      name="birthDay"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>

                                </Col>


                                <Col sm="2">
                                  {isResponsive ? (
                                    <button type="submit" className="btn btn-primary mb-4"><i className=" bx bx-plus-medical"></i></button>
                                  ):(
                                    <button type="submit" className="btn btn-primary mt-27"><i className=" bx bx-plus-medical"></i></button>
                                  )}

                                </Col>
                              </Row>
                              <Row>
                                <Col sm="12">
                                  <h5 className="card-title">Childs</h5>
                                  <div className="table-responsive">
                                    <table className="table table-bordered border-primary">
                                      <thead className="">
                                        <tr>
                                          <th style={{ width: "10%" }}>#</th>
                                          <th style={{ width: "80%" }}>Name</th>
                                          <th style={{ width: "80%" }}>BirthDay</th>
                                          <th style={{ width: "10%" }}>Action</th>
                                        </tr>
                                      </thead>
                                          <tbody>
                                          {map(this.state.childs, (children, datekey) => (
                                                        <tr key={"_note_" + datekey}>
                                                        <td>{datekey + 1 }</td>
                                                        <td> {children.childName} </td>
                                                        
                                                        <td> <Moment format='D MMM YYYY'>{children.birthDay}</Moment></td>
                                                        
                                                        
                                                        <td><ActionDelete onClick={() => this.handleIChildDelete(children.id)} /></td>
                                                        </tr>
                                                      ))} 
                                          </tbody>
                                    </table>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Form>
                      )}
                    </Formik>
                  </TabPane>
                </TabContent>






              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>


    );
  }
}
ContactAdditionProfile.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  onGetContactDetail: PropTypes.object,
  contactDetail: PropTypes.object,
  isResponsive:PropTypes.object
}
const mapStateToProps = ({ contact }) =>
({
  contactDetail: contact.contactDetail,

});
const mapDispatchToProps = dispatch => ({
  onGetContactDetail: id => dispatch(getContactDetail(id)),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactAdditionProfile)))